export const getStatusBackgroundClass = status => {
  switch (status?.toLowerCase().trim()) {
    case 'specialvisit':
      return '!bg-gray-500';
    case 'normal':
      return '!bg-gray-300';
    default:
      return '!bg-[#333]';
  }
};

export const getVisitColor = type => {
  switch (type?.toLowerCase().trim()) {
    case 'appointment':
      return '!bg-blue/10';
    case 'visit':
      return '!bg-gray-200';
    case 'break':
      return '!bg-red-50';
    case 'mixed':
      return '!bg-primary/10';
    default:
      return '!bg-white';
  }
};
